export default __webpack_public_path__ + "static/media/placeholder.b0afed01.svg";